<template>
  <div class="page_container">
    <div class="header"></div>
    <div class="mid_pic">
      <img :src="require('./assets/Pictures/mobile_pic.svg')" alt="">
    </div>
    <div class="text">To provide you with a better experience, please move to your computer and open this website</div>
    <div class="text">
      Meanwhile, if you have any questions that you would like to provide feedback on, 
      <span class="blue">you can enter our Discord</span>
      and we are always online
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileIndex'
}
</script>

<style lang="scss" scoped>
.page_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  .mid_pic {
    width: 227px;
    height: 81px;
    margin: 15px 0;
    img {
      width: 100%;
      height: 100%; 
      object-fit: cover;
    }
  }
  .text {
    color: #000;
    text-align: center;
    font-family: 'Quicksand';
    margin: 15px 30px;
    font-size: 14px;
    font-weight: 400;
    .blue {
      color: #0068E1;
      font-weight: 600;
    }
  }
}
</style>  